import { render, staticRenderFns } from "./CyberpunkTable.vue?vue&type=template&id=4fa8f4cb&scoped=true&"
import script from "./CyberpunkTable.vue?vue&type=script&lang=js&"
export * from "./CyberpunkTable.vue?vue&type=script&lang=js&"
import style0 from "./CyberpunkTable.vue?vue&type=style&index=0&id=4fa8f4cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8f4cb",
  null
  
)

export default component.exports